// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deadlines {
  width: 100%;
}
.deadlines__label {
  color: var(--sebrae-gray);
  font-size: 16px;
}
.deadlines__wrapper {
  display: flex;
  gap: 16px;
  overflow-y: auto;
  scrollbar-color: var(--sebrae-light-gray2) transparent !important;
  margin: 16px -16px;
  padding: 0 0 5px 16px;
}
.deadlines__item {
  cursor: pointer;
  width: 66px;
  min-width: 66px;
  height: 40px;
  background: var(--sebrae-white);
  border: 1px solid var(--sebrae-light-gray2);
  color: var(--sebrae-gray);
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.deadlines__item.active {
  background: var(--sebrae-blue-6);
  border-color: var(--sebrae-blue-6);
  color: var(--sebrae-white);
  font-weight: 700;
}
.deadlines__item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
@media screen and (min-width: 1024px) {
  .deadlines__wrapper {
    flex-wrap: wrap;
    margin: 16px 0 32px;
    gap: 17px;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/planning/components/deadlines/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,yBAAA;EACA,eAAA;AACJ;AACE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,iEAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AACE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;EACA,2CAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kDAAA;AACJ;AACI;EACE,gCAAA;EACA,kCAAA;EACA,0BAAA;EACA,gBAAA;AACN;AAEI;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AAAN;AAIE;EACE;IACE,eAAA;IACA,mBAAA;IACA,SAAA;IACA,UAAA;EAFJ;AACF","sourcesContent":[".deadlines {\n  width: 100%;\n\n  &__label {\n    color: var(--sebrae-gray);\n    font-size: 16px;\n  }\n  &__wrapper {\n    display: flex;\n    gap: 16px;\n    overflow-y: auto;\n    scrollbar-color: var(--sebrae-light-gray2) transparent!important;\n    margin: 16px -16px;\n    padding: 0 0 5px 16px;\n  }\n  &__item {\n    cursor: pointer;\n    width: 66px;\n    min-width: 66px;\n    height: 40px;\n    background: var(--sebrae-white);\n    border: 1px solid var(--sebrae-light-gray2);\n    color: var(--sebrae-gray);\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    &.active {\n      background: var(--sebrae-blue-6);\n      border-color: var(--sebrae-blue-6);\n      color: var(--sebrae-white);\n      font-weight: 700;\n    }\n\n    &.disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      pointer-events: none;\n    }\n  }\n\n  @media screen and (min-width: 1024px) {\n    &__wrapper {\n      flex-wrap: wrap;\n      margin: 16px 0 32px;\n      gap: 17px;\n      padding: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
